import { render, staticRenderFns } from "./zzns.vue?vue&type=template&id=1e9764f8&scoped=true"
import script from "./zzns.vue?vue&type=script&lang=js"
export * from "./zzns.vue?vue&type=script&lang=js"
import style0 from "./zzns.vue?vue&type=style&index=0&id=1e9764f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9764f8",
  null
  
)

export default component.exports